/**
 * Download de blob autenticado no padrão do Hub (PO1-2895): o arquivo já veio
 * pelo axios (responseType: "blob"), aqui só vira <a download>. Nunca
 * window.open, que perderia o Authorization. Mesmo corpo que os viewers de
 * components/autopilot/*ViewerModal.js usavam inline; centralizado para não
 * nascer mais uma cópia por tela.
 *
 * @param {Blob|ArrayBuffer|string} conteudo
 * @param {string} nomeArquivo
 * @param {string} [mime] opcional; quando omitido usa o type do Blob recebido
 */
export function downloadBlob(conteudo, nomeArquivo, mime) {
  const blob =
    conteudo instanceof Blob && !mime ? conteudo : new Blob([conteudo], mime ? { type: mime } : undefined);
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = nomeArquivo || "download";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export default downloadBlob;
